import { formOptions } from '@tanstack/react-form';
import { LoginFormSchema, type LoginFormInput } from './LoginFormSchema';

export const loginFormOptions = formOptions({
  formId: 'datev-login',
  defaultValues: {
    mandantennummer: '',
    beraternummer: '',
    lohnabrechnungsart: 'LODAS',
  } satisfies LoginFormInput as LoginFormInput,
  validators: {
    onSubmit: LoginFormSchema,
  },
  onSubmit: () => {
    // TODO Login
  },
});
